import { Teleport } from 'vue';
import Field from 'vant/lib/field';
import 'vant/lib/field/style';

import iconTip from '@a/assets/images/i_important.png';

export default function FormInput(props: any, { slots, emit }: any) {
  const value = computed({
    get() {
      return props.modelValue;
    },
    set(val: string) {
      emit('update:modelValue', val);
    }
  });

  const errorRef = ref<HTMLElement | null>(null);

  // const instance = getCurrentInstance()
  // console.log('instance', instance?.parent?.provides)

  const validateMap = inject('validateMap') as { value: Record<string, number> } | undefined;
  const endValidate = ({ status }: { status: string }) => {
    if (validateMap) {
      validateMap.value[props.name] = status === 'passed' ? 1 : 0;
    }
  };
  
  const slotsData = {
    "error-message": ({ message }: { message: string }) => (
        errorRef.value ? 
        (<Teleport to={errorRef.value}>
          <div
            class="bg-[var(--input-tip-bg-color)] text-[#FFFFFF80] rounded-[8px] flex p-[8px_16px] mt-[8px]"
          >
            <img
              class="size-[18px] opacity-50 mr-[8px]"
              src={iconTip}
              alt="Tip"
            />
            <span class="text-[11px]">
              {message}
            </span>
          </div>
        </Teleport>)
        : null
    )
  }

  if (slots["left-icon"]) slotsData["left-icon"] = () => slots["left-icon"]?.()
  if (slots["right-icon"]) slotsData["right-icon"] = () => slots["right-icon"]?.()
  if (slots.errorTip) {
    slotsData["error-message"] = ({ message }: { message: string }) => (
      errorRef.value ?
        (<Teleport to={errorRef.value}>
          {slots.errorTip?.({ message })}
        </Teleport>)
      : null
    )
  }

  return (
    <div>
      <Field
        modelValue={value.value}
        autocomplete="off"
        autocapitalize="off"
        onEndValidate={endValidate}
        {...props}
        v-slots={slotsData}
      />
      <div ref={errorRef}></div>
      {slots.extraTip?.()}
    </div>
  );
}
